import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { htmlSafe } from '@ember/template';

export default Helper.extend({
  taskService: service(),

  compute(args /*namedArgs*/) {
    let task = args[0];
    return htmlSafe(this.taskService.actionLabelsById[task.actionId]);
  },
});
